// extracted by mini-css-extract-plugin
export default {"servicesCard":"Services_servicesCard__O1vZl","icon":"Services_icon__azJ3p","servicesWrapper":"Services_servicesWrapper__MYy+N","pos":"Services_pos__Zaqbi"};